/**
 * automatedSystems.js — content module for /automated-systems spoke page.
 * Source: docs/rebuild/content/website/03-offers.md (Card A)
 */

export const automatedSystemsHead = {
  eyebrow: 'Fully Automated Business Systems',
  heading: 'Fully Automated Business Systems',
  subheading: 'Custom AI automation for businesses with a specific operational pain.',
};

export const automatedSystemsIntro =
  'For businesses with a bounded, specific operational pain. Not a platform. Not a compliance suite. A targeted system that removes bottlenecks. This is how most of our services engagements start.';

export const shapes = {
  heading: 'Shapes we have built or scoped',
  items: [
    'Email triage moving 300 inbound emails a day down to only 5 human escalations',
    'Invoice processing connecting an email inbox to Xero and a CRM',
    'Voice AI for inbound with 100% bookings automated',
    'Project management overhauls for teams still emailing status between departments',
    'Net-new platform MVPs (driving-test booking, reusable crate logistics, legal paperwork digitisation)',
    'Single-integration builds (Karbon to Mailchimp, Xero to Pipedrive, Calendly to Notion)',
  ],
};

export const engagementIncludes = {
  heading: 'What every engagement includes',
  items: [
    'PRD locked at signing, change orders for any scope expansion',
    'Milestone-based delivery, senior engineer on the engagement for the duration',
    'Staff training on what we built',
    'Source code delivered to your repo on completion, no lock-in',
  ],
};

export const automatedSystemsCta = {
  label: 'Scope a system',
};

export const automatedSystemsLinks = {
  foundry: { href: '/foundry', label: 'Would rather build this yourself? The Foundry teaches the same playbook.' },
  teamTraining: { href: '/team-training', label: 'Upskill your team alongside the build.' },
  systems: { href: '/systems', label: 'AI-native business systems' },
};
